export const Z_INDEX = {
    MESSAGE: 1000,
    LOADING: 999,
    MODAL: 998,
    POPUP: 997,
    TOOLTIP: 996,
    CONFIG_HEADER: 995,
    STICKY_HEADER: 994,
};
